export enum MicOption {
	BUILT_IN = "Built-In",
	LINE_IN = "Line-In"
}
